export const query = state => {
  return {
    tradeName: state.tradeName,
    name: state.name,
    document: state.document,
    source: state.source,
    department: state.department,
    managerbodyCode: state.managerbodyCode,
    receiverCode: state.receiverCode
  }
}

export const loaded = (state) => {
  return state.loaded
}
